/** Max dots shown for image carousels (sliding window when there are more images). */
export const MAX_CAROUSEL_DOTS = 8;

/**
 * Returns which image indices should render as dots. When total > maxDots,
 * uses a sliding window that keeps the current index visible and biased
 * toward the center of the window.
 *
 * @param {number} total - number of images
 * @param {number} currentIndex - 0-based active image index
 * @param {number} [maxDots=MAX_CAROUSEL_DOTS]
 * @returns {number[]}
 */
export function getVisibleDotIndices(total, currentIndex, maxDots = MAX_CAROUSEL_DOTS) {
  const n = Math.max(0, Math.floor(Number(total)) || 0);
  if (n === 0) return [];
  if (n <= maxDots) {
    return Array.from({ length: n }, (_, i) => i);
  }
  const half = Math.floor((maxDots - 1) / 2);
  const safeCurrent = Math.min(Math.max(0, Math.floor(currentIndex)), n - 1);
  const start = Math.max(0, Math.min(safeCurrent - half, n - maxDots));
  return Array.from({ length: maxDots }, (_, i) => start + i);
}
